/**
 * Fişin "SİPARİŞ" satırına (yerel servis) basılacak numara.
 *
 * Yerel servis başlığa `orderNumber` basar (normal fişte ilk 14 karakter). Telefon
 * siparişinde `orderNumber` uzun numaradır (PKT-20261021-143000-012) ve kesilince
 * "PKT-20261021-1" gibi anlamsız bir değer çıkıyordu; kısa numara (PKT-12) hiç
 * basılmıyordu. Kural: kısa kod varsa, uzun numaradan kısaysa ve uzun numaranın
 * içinde zaten geçmiyorsa kısa kod basılır. "TRENDYOL #123" gibi kısa kodu zaten
 * içeren platform etiketleri olduğu gibi kalır.
 */
export function printedOrderNumber(orderNumber?: string | null, shortCode?: string | null): string {
  const long = (orderNumber || '').trim();
  const short = (shortCode || '').trim();
  if (!short) return long;
  if (!long) return short;
  if (short.length >= long.length || long.includes(short)) return long;
  return short;
}

/**
 * Yerel servise giden sipariş numarası alanları: fişte yalnız kısa numara basılır.
 * `hideFisNo` yerel servise "Fis No" satırını basmamasını söyler. Eski yerel servis
 * bu işareti tanımaz; o da invoiceNumber'ı basar, bu yüzden oraya da kısa numara
 * gönderilir (uzun numara hiçbir durumda fişe çıkmaz).
 */
export function localServiceOrderFields(orderNumber?: string | null, shortCode?: string | null) {
  const printed = printedOrderNumber(orderNumber, shortCode);
  return {
    orderNumber: printed,
    invoiceNumber: printed,
    hideFisNo: true,
  };
}
